import React, { useState } from 'react';

const catServices = [
  {
    icon: "🐱🛁", 
    title: "Bath + Basic",
    oldPrice: "₹1438",
    newPrice: "₹1199",
    description: "Coupons Available on Mobile App. Download now→",
    button: "Book A Groomer",
    features: [
      "Bath With Shampoo & Conditioner",
      "Blow Dry",
      "Nail Clipping",
      "Ear Cleaning",
      "Eye Cleaning",
      "Paw Massage",
      "Combing/Brushing",
      "Face Haircutting",
      "Sanitary Trim",
    ],
  },
  {
    icon: "🐱✨", 
    title: "Full Service",
    oldPrice: "₹2398",
    newPrice: "₹1999",
    description: "Coupons Available on Mobile App. Download now→",
    button: "Book A Groomer",
    features: [
      "Bath With Shampoo & Conditioner",
      "Blow Dry",
      "Full body Trimming/Zero Haircut",
      "Body Massage",
      "Sanitary Trim",
      "Nail Clipping",
      "Ear Cleaning",
      "Eye Cleaning",
      "Paw Massage",
      "Combing/Brushing",
    ],
  },
  {
    icon: "🐱💆", 
    title: "Trans-fur-mation",
    oldPrice: "₹1798",
    newPrice: "₹1499",
    description: "Coupons Available on Mobile App. Download now→",
    button: "Book A Groomer",
    features: [
      "Full Body Trimming",
      "Ear Cleaning",
      "Eyes Cleaning",
      "Nail Clipping",
    ],
  },
];

const CatGrooming = () => {
  return (
    <div className="bg-gray-100 py-10 mt-10">
      <div className="text-center">
        <p className="text-4xl font-bold">Cat Grooming Packages</p>
        <p className="mt-4">Charges may vary based on Pet and City.</p>
      </div>

      <div className="container mx-auto px-4 grid gap-8 md:grid-cols-2 lg:grid-cols-3 mt-10">
        {catServices.map((service, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-lg p-6 flex flex-col justify-between text-center"
          >
            
            <div>
              <div className="text-4xl">{service.icon}</div>
              <h2 className="text-xl font-bold mt-4">{service.title}</h2>
              <div className="mt-2">
                <span className="line-through text-gray-500">{service.oldPrice}</span>{" "}
                <span className="text-green-500 font-bold">{service.newPrice}</span>
              </div>
              <p className="text-sm text-gray-600 mt-2">{service.description}</p>
            </div>

            
            <ul className="text-left mt-4">
              {service.features.map((feature, idx) => (
                <li key={idx} className="flex items-center gap-2 text-sm mb-2">
                  <span className="text-green-500">✔</span>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            
            <button
              onClick={() => alert(`Booking for ${service.title}`)}
              className="bg-orange-500 mt-4 w-full rounded-xl h-10 text-white font-bold text-sm"
            >
              {service.button}
            </button>
          </div>
        ))}
      </div>
      <div className="bg-gray-100 py-10 mt-10">
      <div className="container mx-auto px-4 text-center">
        <p className="text-3xl font-bold mb-4">Professional Grooming Experience</p>
        <p className="text-xl mb-6">
          Professional Grooming Experience of minimum 2+ years is mandatory for all groomers on Adopt a Pet.
          We verify each and every groomer to ensure that your pet is in safe & skilled hands.
        </p>

        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-center items-center text-green-500 mb-4">
            <span className="text-2xl">✔</span>
            <p className="ml-2 text-xl">All our Groomers pass Adopt a Pet Enhanced Background Check.</p>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default CatGrooming;
